// extracted by mini-css-extract-plugin
module.exports = {"loadingWrap":"Loading_loadingWrap__Td9Se","loading":"Loading_loading__WJJX0","loadingInline":"Loading_loadingInline__RUUny","loadingFullScreen":"Loading_loadingFullScreen__84kv0"};